module.exports = __webpack_public_path__ + "img/epr@2x.12a18660.jpeg";